import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { MarkSimsonTutorialAsSeenInputs } from 'frontend/types/lessons/requests';
import { postData } from 'frontend/utils/ajax';

const profileModule: Module<null, RootState> = {
  namespaced: true,
  actions: {
    async markSimsonTutorialAsSeen(_, { data }: MarkSimsonTutorialAsSeenInputs): Promise<void> {
      await postData('/api/v1/profile_card/mark-simson-tutorial-as-seen/', data);
    },
  },
  getters: {},
};

export default profileModule;
